import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { ScheduleParameters } from '../models/ScheduleParameters';
import { Customer } from '../models/Customer';
import { TruckerItem } from "../models/TruckerItem";
import { DispatchItem } from "../models/DispatchItem";
import { DispatchParameters } from "../models/DispatchParameters";
import { ScheduleDataService } from '../services/schedule-data.service';
import { MoveSplitDispatchParameters } from '../models/MoveSplitDispatchParameters';
import { AlertParameters } from '../models/AlertParameters';
import { EmailQuestionFormParameters } from '../models/EmailQuestionFormParameters';
import { RoundParameters } from '../models/RoundParameters';
import { RoundCompleteEvent } from '../models/RoundCompleteEvent';
import { ToastNotificationComponent } from '../toast-notification/toast-notification.component';
import { DeleteParameters } from '../models/DeleteParameters';
import { DeleteComponent } from '../delete-confirm/delete-confirm.component';
import { LocationType } from '../models/Enums';
import { CopyDispatchParameters } from '../models/CopyDispatchParameters';


@Component({
    selector: 'trucker-summary',
    templateUrl: 'trucker-summary.component.html',
    styleUrls: ['trucker-summary.component.css'],
    standalone: false
})
export class TruckerSummaryComponent implements OnInit, OnChanges {

    constructor(private _scheduleDataService: ScheduleDataService) { }

    @ViewChild('toastNotification') toastNotification: ToastNotificationComponent;
    @ViewChild('deleteConfirmChildComponent') deleteConfirmChildComponent!: DeleteComponent;
    @Input() scheduleParameters: ScheduleParameters;
    
    truckerItem: TruckerItem = new TruckerItem();
    truckerList: TruckerItem[] = [];
    filteredTruckersList: TruckerItem[] = [];
    customerItem: Customer = new Customer();
    customerItems: Customer[] = [];
    dispatchItem: DispatchItem = new DispatchItem();
    dispatchList: DispatchItem[] = [];
    selectedTrucker: number = 0;
    selectedTruckerName: string = '';
    searchTermTrucker: string = '';
    searchTermCode: string = '';
    errorMessage: string = '';
    tableHeight: number = 0;
    totalColumnWidths: number = 0;

    // Modals
    dispatchFormParams: DispatchParameters = new DispatchParameters();
    copyDispatchParameters: CopyDispatchParameters = new CopyDispatchParameters();
    deleteItemParams: DeleteParameters = new DeleteParameters();
    moveSplitDispatchFormParams: MoveSplitDispatchParameters = new MoveSplitDispatchParameters();
    alertTruckerParams: AlertParameters = new AlertParameters();
    emailQuestionParams: EmailQuestionFormParameters = new EmailQuestionFormParameters();
    roundParams: RoundParameters = new RoundParameters();

    dispatchFormId: string = 'truckerDispatchModal';
    copyDispatchModalId: string = 'truckerCopyDispatchModal';
    deleteFormId: string = 'truckerDeleteModal';
    moveSplitFormId: string = 'truckerMoveSplitModal';
    alertTruckerFormId: string = 'truckerAlertModal';
    roundFormId: string = 'truckerRoundModal';
    copyRoundFormId: string = 'truckerCopyRoundModal';
    emailQuestionFormId: string = 'truckerQuestionEmailModal';
    loadsStatusFormId: string = 'truckerloadsStatusModal';
    confirmDispatchFormId: string = 'truckerConfirmDispatchModal';
    confirmTruckersFormId: string = 'truckerConfirmTruckersModal';

    loadsStatusRefresh: boolean = false;
    loadsStatusDispatchId: number = 0;
    sendDispatchId: number = 0;
    sendDispatchRefresh: boolean = false;
    confirmTruckerId: number = 0;
    searchTrucker = '';
    searchCode = '';

    refreshData() {
        if (this.selectedTrucker != 0) {
            this.selectedTrucker = 0;
        }
        if (this.scheduleParameters.locCode.length === 0) {
            return;
        }
        this.getTruckersForSchedules();
    }

    getTruckersForSchedules() {
        this._scheduleDataService.getTruckersForSchedules(this.scheduleParameters).subscribe({
            next: data => {
                this.truckerList = data;
                this.filteredTruckersList = data;
            },
            error: err => this.errorMessage = err
        });
    }

    filterTruckersList() {
        const trucker = this.searchTrucker.toLowerCase();
        const code = this.searchCode.toLowerCase();
        this.filteredTruckersList = this.truckerList.filter(item =>
            (item.customerName?.toLowerCase().includes(trucker)) &&
            (item.customerCode?.toLowerCase().includes(code))
        );
    }

    selectTrucker(trucker: TruckerItem): void {
        this.truckerList.forEach(t => t.isSelected = false);
        trucker.isSelected = true;
        this.selectedTrucker = trucker.customerId;
        this.selectedTruckerName = trucker.customerName;
        this.getTruckerDispatchesById();
    }

    getTruckerDispatchesById() {
        this._scheduleDataService.getTruckerDispatchesById(this.selectedTrucker, this.scheduleParameters).subscribe({
            next: data => {
                this.dispatchList = data;
            }
        })
    }

    setTableHeight() {
        let screenHeight = window.innerHeight;
        let screenModifier = .81; //Default for 24" monitors (952px)

        if (screenHeight < 850) { //For laptop displays (838px)
            screenModifier = .78;
        }

        return this.tableHeight = screenHeight * screenModifier;
    }

    editDispatch(dispatchId) {
        let parms = new DispatchParameters();
        parms.dispatchId = dispatchId;
        this.dispatchFormParams = parms;
    }

    copyDispatch(dispatchId: number) {
        let parms = new CopyDispatchParameters();
        parms.locCode = this.scheduleParameters.locCode;
        parms.planPeriod = this.scheduleParameters.planPeriod;
        parms.periodStartDate = this.scheduleParameters.periodStartDate;
        parms.periodEndDate = this.scheduleParameters.periodEndDate;
        parms.dispatchId = dispatchId;
        this.copyDispatchParameters = parms;
    }

    deleteDispatch(dispatchId: number) {
        let parms = new DeleteParameters()
        parms.dispatchId = dispatchId;
        parms.title = `Are you sure you want to delete the dispatch for ${this.selectedTruckerName}?`
        this.deleteItemParams = parms;
        return false;
    }

    deleteItem(event: boolean, deleteItem: DeleteParameters) {
        if (event) {
            if (deleteItem.dispatchId > 0) {
                this._scheduleDataService.getDispatch(deleteItem.dispatchId).subscribe({
                    next: () => {
                        this.deleteConfirmChildComponent.close();
                        const index = this.dispatchList.findIndex(dispatch => dispatch.dispatchId === deleteItem.dispatchId);

                        if (index !== -1) {
                            this.dispatchList.splice(index, 1);
                        }
                    },
                    error: err => this.errorMessage = err
                })
            }
        }
    }

    moveSplitDispatch(scheduleId: number, dispatchId: number, type: LocationType) {
        let parms = new MoveSplitDispatchParameters();
        parms.scheduleId = type == this.scheduleParameters.locationType ? scheduleId : 0;
        parms.dispatchId = dispatchId;
        parms.periodStartDate = this.scheduleParameters.periodStartDate;
        parms.periodEndDate = this.scheduleParameters.periodEndDate;
        parms.planPeriod = this.scheduleParameters.planPeriod;
        parms.scheduleParameters = { ...this.scheduleParameters }; 
        parms.scheduleParameters.truckerId = 0;
        parms.scheduleParameters.locationId = 0;
        parms.scheduleParameters.loadDate = "";
        parms.scheduleParameters.deliveryDate = "";
        this.moveSplitDispatchFormParams = parms;
    }

    alertTrucker(scheduleId: number, dispatchId: number, isRequestFromSendTextAlertForm: boolean) {
        let parms = new AlertParameters();
        parms.scheduleId = scheduleId;
        parms.dispatchId = dispatchId;
        parms.truckerId = this.selectedTrucker;
        parms.periodStartDate = this.scheduleParameters.periodStartDate;
        parms.periodEndDate = this.scheduleParameters.periodEndDate;
        parms.selectedLocCodeInFilter = this.scheduleParameters.locCode;
        parms.isRequestFromSendTextAlertForm = isRequestFromSendTextAlertForm;
        this.alertTruckerParams = parms;
    }

    getEmailQuestionDetails(scheduleId: number, dispatchId: number) {
        let parms = new EmailQuestionFormParameters()
        parms.scheduleId = scheduleId;
        parms.dispatchId = dispatchId;
        parms.periodStartDate = this.scheduleParameters.periodStartDate;
        parms.periodEndDate = this.scheduleParameters.periodEndDate;
        parms.locationType = this.scheduleParameters.locationType;
        this.emailQuestionParams = parms;
    }

    openRound(roundId: number, dispatchId: number) {
        let parms = new RoundParameters();
        parms.roundId = roundId;
        parms.dispatchId = dispatchId;
        parms.locCode = this.scheduleParameters.locCode;
        parms.periodStartDate = this.scheduleParameters.periodStartDate;
        parms.periodEndDate = this.scheduleParameters.periodEndDate;
        this.roundParams = parms;
    }

    showRogerLoadsStatus(dispatchId: number) {
        this.loadsStatusDispatchId = dispatchId;
        this.loadsStatusRefresh = !this.loadsStatusRefresh;
        return false;
    }

    scheduleSaveComplete(scheduleId: number) {
        this.getTruckerDispatchesById();
    }

    roundComplete(eventParms: RoundCompleteEvent) {
        this.getTruckerDispatchesById();
        this.toastNotification.showToast(eventParms.message, 3000, "success");
    }

    sendDispatch(dispatchId: number) {
        this.confirmTruckerId = 0;
        this.sendDispatchId = dispatchId;
        this.sendDispatchRefresh = !this.sendDispatchRefresh;
    }

    confirmTrucker(truckerId: number) {
        this.confirmTruckerId = truckerId;
        this.sendDispatchRefresh = !this.sendDispatchRefresh;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['scheduleParameters']) {
            this.refreshData();
        }
    }

    ngOnInit(): void {
        this.setTableHeight();
        window.addEventListener('resize', () =>
            this.setTableHeight());
    }

    getExecutedCount(dispatch: DispatchItem): number {
        if (!dispatch.loadList) return 0;
        return dispatch.loadList.filter(l => l.preAdvise || l.delivered).length;
    }

    getTotalCount(dispatch: DispatchItem): number {
        return dispatch.loadList?.length ?? 0;
    }

    getExecutedPercentage(dispatch: DispatchItem): number {
        const total = this.getTotalCount(dispatch);
        if (total === 0) return 0;
        return Math.round((this.getExecutedCount(dispatch) / total) * 100);
    }

    getTruckerExecutedPercentage(trucker: TruckerItem): number {
        if (trucker.totalLoads === 0) return 0;
        return Math.round((trucker.executedLoads / trucker.totalLoads) * 100);
    }
}
